import { AppUtilsContext, IAppUtilsContext } from "@providers/AppUtilsProvider";
import { useContext } from "react";

const useAppContext = (): IAppUtilsContext => {
  return useContext(AppUtilsContext) as IAppUtilsContext;
};

export default useAppContext;
